"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _withIconComponent = _interopRequireDefault(require("../../../withIconComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CheckCircle08 = function CheckCircle08() {
  return /*#__PURE__*/_react["default"].createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6 12l4 4 8-8",
    stroke: "#FF6400",
    "data-color": "color-2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 1a11 11 0 1 0 0 22 11 11 0 1 0 0-22z",
    stroke: "#404040"
  }));
};

var _default = (0, _withIconComponent["default"])("NucleoSmallUserInterfaceCheckCircle08", false)(CheckCircle08);

exports["default"] = _default;